import { render, staticRenderFns } from "./ownersTable.vue?vue&type=template&id=89cf1e10&scoped=true"
import script from "./ownersTable.vue?vue&type=script&lang=js"
export * from "./ownersTable.vue?vue&type=script&lang=js"
import style0 from "./ownersTable.vue?vue&type=style&index=0&id=89cf1e10&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89cf1e10",
  null
  
)

export default component.exports